export default "__VITE_ASSET__58997718__"